import html from './html';
import node from './node';

export default {html, node};